export class ApiError extends Error {
  constructor(message, { status = 0, code = 'NETWORK_ERROR' } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.retryable = !status || status === 408 || status === 429 || status >= 500 || code === 'INVALID_RESPONSE';
  }
}

export async function readApiResponse(response) {
  let data;
  try { data = await response.json(); }
  catch { throw new ApiError('El servicio no pudo responder. Intenta de nuevo.', { status: response.status, code: 'INVALID_RESPONSE' }); }
  if (!response.ok || !data?.success) {
    const message = response.status >= 500 ? 'El servicio está temporalmente ocupado. Intenta de nuevo.'
      : data?.error || data?.message || 'No se pudo completar la solicitud.';
    throw new ApiError(message, { status: response.status,
      code: data?.code || (response.status === 401 ? 'SESSION_EXPIRED' : 'REQUEST_FAILED') });
  }
  return data;
}

// Bound reads only. Never automatically repeat writes or payment requests.
export async function requestJson(url, options = {}, { timeoutMs = 15000, fetchImpl = fetch } = {}) {
  const controller = new AbortController();
  const parentSignal = options.signal;
  const cancel = () => controller.abort(parentSignal.reason);
  if (parentSignal?.aborted) cancel();
  else parentSignal?.addEventListener('abort', cancel, { once: true });
  let timedOut = false;
  const timer = setTimeout(() => { timedOut = true; controller.abort(); }, timeoutMs);
  try {
    return await readApiResponse(await fetchImpl(url, { ...options, signal: controller.signal }));
  } catch (error) {
    if (parentSignal?.aborted) throw error;
    if (error instanceof ApiError) throw error;
    throw new ApiError(timedOut ? 'La conexión tardó demasiado. Puedes reintentar.'
      : 'No pudimos conectar. Comprueba tu conexión y vuelve a intentar.', { code: timedOut ? 'REQUEST_TIMEOUT' : 'NETWORK_ERROR' });
  } finally {
    clearTimeout(timer);
    parentSignal?.removeEventListener('abort', cancel);
  }
}

export function profileFailureRoute(error) {
  if (error.code === 'TRIAL_EXPIRED') return '/trial/status';
  if (error.code === 'TRIAL_NOT_ACTIVATED') return '/trial/start';
  if (error.status === 401) return '/login';
  return null;
}
